import { styled } from '@mui/material'
import Typography from '@mui/material/Typography'
import ErrorGraphic from './Graphic'
import BackToEnquiryLink from '../../Views/VenueResponsePage/Components/ResponseNav/BackToEnquiryLink'

const ErrorContainer = styled('article')(({ theme }) => ({
  '& > header': { margin: 16 },
  '& > .graphic': {
    width: '100%',
    height: 'auto',
    maxWidth: 492,
    maxHeight: 368,
    margin: '32px auto',
    display: 'block',
  },
  '& > .errorBody': {
    fontWeight: 500,
    textAlign: 'center',
    margin: '0 16px',
  },
  [theme.breakpoints.up('sm')]: {
    '& > header': { margin: '16px 0' },
    '& > .errorBody': { margin: 0 },
  },
}))

interface BaseErrorPageProps {
  children: React.ReactChild | React.ReactChild[]
  accessSecret?: string
}

const BaseErrorPage: React.FC<BaseErrorPageProps> = ({
  accessSecret,
  children,
}) => {
  return (
    <ErrorContainer>
      {accessSecret && (
        <header className='header'>
          <BackToEnquiryLink />
        </header>
      )}
      <ErrorGraphic className='graphic' />
      <Typography variant='body1' className='errorBody'>
        {children}
      </Typography>
    </ErrorContainer>
  )
}

export default BaseErrorPage
